import React from 'react';
import { Box } from '@material-ui/core';
import publicIp from 'public-ip';

export const getClientIp = async () => await publicIp.v4({
  fallbackUrls: [ "https://ifconfig.co/ip" ]
});

export const capitalize = (str) => {
  const newStr = str.toLowerCase().replace(/-/gi, ' ');
  return newStr.charAt(0).toUpperCase() + newStr.slice(1);
};

export const removeNullProps = (obj) => {
  for (let prop in obj) {
    if (!obj[prop]) {
      delete obj[prop];
    }
  }
  return obj;
};

export const wait = (time) => new Promise((res) => setTimeout(res, time));

export const shortenString = (str, len = 45) => {
  if (str.length > len) {
    return str.slice(0, len - 1) + '...';
  }
  return str;
};

export const parseErrors = (errors) => (
  <Box>
    Os seguintes erros foram encontrados:{' '}
    {Object.entries(errors).map((error) => (
      <li key={error[1]}>{error[1]}</li>
    ))}
  </Box>
);

export const dateFormat = (date, size) => {
  let parsedDate;
  if (typeof date === 'string') {
    parsedDate = new Date(date);
  } else {
    parsedDate = date;
  }
  const options = {};
  switch (size) {
    case 'year':
      options.year = 'numeric';
      break;

    case 'month-year':
      options.year = 'numeric';
      options.month = 'long';
      break;

    case 'day-month-year':
      options.year = 'numeric';
      options.month = 'long';
      options.day = 'numeric';
      break;

    default:
      break;
  }
  return parsedDate.toLocaleDateString('pt-br', options);
};
